module.exports = __webpack_public_path__ + "static/media/btn-exequial.89f1a078.png";